// src/sentry.ts
import * as Sentry from '@sentry/react';
import { useEffect } from 'react';

import {
    createRoutesFromChildren,
    matchRoutes,
    useLocation,
    useNavigationType,
  } from "react-router-dom";
import { ENABLE_SENTRY } from './env';

Sentry.init({
    enabled: ENABLE_SENTRY === "true",
    dsn: "https://e6b104ce8d175ba47a5024fc60decda6@o498273.ingest.us.sentry.io/4509726752571392",
    sendDefaultPii: true,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.reactRouterV6BrowserTracingIntegration({
        useEffect: useEffect,
        useLocation,
        useNavigationType,
        createRoutesFromChildren,
        matchRoutes,
      }),
    ],
    tracesSampleRate: 0.5, //  Capture 50% of the transactions
    beforeSend(event) {
      if (window.location.hostname === "localhost") {
        return null; // Drop event
      }
      return event;
    },
  });
